export const normalizeStandingInstructions = (value) => {
  if (!value || typeof value !== 'object') return undefined;

  const context = typeof value.context === 'string' ? value.context.trim() : '';
  const outputRules = typeof value.outputRules === 'string' ? value.outputRules.trim() : '';
  const enabled = typeof value.enabled === 'boolean' ? value.enabled : true;

  if (!context && !outputRules) return undefined;

  return {
    ...(context ? { context } : {}),
    ...(outputRules ? { outputRules } : {}),
    enabled,
  };
};

export const hasStandingInstructions = (value) => {
  const normalized = normalizeStandingInstructions(value);
  return Boolean(normalized?.context || normalized?.outputRules);
};

export const buildStandingInstructionsPrompt = (prompt, value, enabled = true) => {
  const trimmedPrompt = typeof prompt === 'string' ? prompt.trim() : '';
  if (!trimmedPrompt) return '';

  const normalized = normalizeStandingInstructions(value);
  const isEnabled = typeof enabled === 'boolean' ? enabled : normalized?.enabled !== false;
  if (!isEnabled || !normalized) return trimmedPrompt;

  const parts = [];

  if (normalized.context) {
    parts.push(`Context: ${normalized.context}`);
  }

  parts.push(trimmedPrompt);

  if (normalized.outputRules) {
    parts.push(`Output Rules: ${normalized.outputRules}`);
  }

  return parts.join('\n\n');
};
